import React from "react";
import { weeklyHealthMeta } from "./weeklyModel.js";

export function WeeklyHealthDot({ project, surface }) {
  const health = weeklyHealthMeta(project);
  return (
    <span
      data-testid={`weekly-${surface}-health-${project.id}`}
      data-status={health.status || "unavailable"}
      data-source={health.source}
      role="img"
      aria-label={health.label}
      title={health.label}
      style={{
        display: "inline-block", width: 9, height: 9, flexShrink: 0,
        ...(health.color ? { borderRadius: "50%", background: health.color } : {}),
      }}
    />
  );
}
